// src/components/Posts.jsx
import TimelineBody from "./timeline-body";

export default function Posts() {
  // Just render the full timeline body.
  // The global Layout in App.jsx will wrap this with Header + Footer.
  return <TimelineBody />;
}
